import { IModalProps } from '@components/organisms/modal/Modal';
import { atom } from 'recoil';

export const modalAtom = atom<IModalProps | null>({
  key: `modal/${Math.random()}`,
  default: null,
});
